import { render, staticRenderFns } from "./handleTip.vue?vue&type=template&id=59a43ccd&scoped=true&lang=html"
import script from "./handleTip.vue?vue&type=script&lang=js"
export * from "./handleTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a43ccd",
  null
  
)

export default component.exports